
export const PORTAL_MODE = {
  USER: 'USER',
  PROVIDER: 'PROVIDER'
}
